import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";
import { Reveal, SectionHead } from "../components/site/Motion";
import { ArticleCard } from "../components/site/ArticleCard";
import { CTABand } from "../components/site/CTABand";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { ARTICLES, FAQS } from "../content/insights";

export default function InsightsFaqPage() {
  return (
    <>
      <Seo title="Insights & FAQs" path="/insights" description="Plain-language guides to rooftop solar, open access, group captive, project feasibility and commercial considerations for C&I consumers in India." />
      <PageHero
        eyebrow="Insights & FAQs"
        title={["Solar procurement,", <span className="font-serif-i text-[#3f8a0f]">explained simply.</span>]}
        intro="Educational guides for CFOs, plant heads, procurement and sustainability teams. General information only, not legal, tax or regulatory advice."
      />
      <section className="bg-[#F9F8F3] py-20 md:py-28" data-testid="insights-articles">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <div className="grid gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
            {ARTICLES.map((a, i) => <ArticleCard key={a.slug} a={a} i={i} />)}
          </div>
        </div>
      </section>
      <section id="faqs" className="scroll-mt-24 bg-[#F2EFE7] py-24 md:py-32" data-testid="faq-section">
        <div className="mx-auto grid max-w-[1440px] gap-14 px-5 md:px-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead eyebrow="FAQs" title={["Frequently", "asked questions."]} />
          </div>
          <Reveal className="lg:col-span-8">
            <Accordion type="single" collapsible className="border-t border-[#082619]/15">
              {FAQS.map((f) => (
                <AccordionItem key={f.id} value={f.id} className="border-[#082619]/15" data-testid={`faq-accordion-item-${f.id}`}>
                  <AccordionTrigger className="font-display py-6 text-left text-lg md:text-xl font-medium text-[#082619] hover:no-underline">{f.q}</AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-[#4C6053]">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>
      <CTABand title={["Have a question about", "your own facility?"]} />
    </>
  );
}
